// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/get_campaigns_for_filter" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { analyticsDashboardAppGroupIdGetCampaignsForFilter } from "./constants";
import type { AnalyticsDashboardAppGroupIdGetCampaignsForFilterResult, FiltersParam } from "./types";

export const getAnalyticsDashboardAppGroupIdGetCampaignsForFilter = reactQueryFetcherAdapter(
  analyticsDashboardAppGroupIdGetCampaignsForFilter,
  (
    signal: AbortSignal,
    appGroupId: string,
    filters?: FiltersParam
  ): Promise<AnalyticsDashboardAppGroupIdGetCampaignsForFilterResult> => {
    return fetch(`/analytics_dashboard/${appGroupId}/get_campaigns_for_filter`, "GET", { filters }, { signal });
  }
);
